import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSort, faSortUp, faSortDown } from '@fortawesome/pro-solid-svg-icons'

import { Header } from '../types'
import styles from './SortIcon.module.scss'

interface SortIconProps {
  header: Header
  onClick(): void
}

export const SortIcon = ({ header, onClick }: SortIconProps) => {
  const { order } = header

  const orderComponents: Record<string, JSX.Element> = {
    asc: (
      <div
        className={styles.sort}
        onClick={() => {
          onClick()
        }}
      >
        <FontAwesomeIcon icon={faSortUp} />
      </div>
    ),
    desc: (
      <div
        className={styles.sort}
        onClick={() => {
          onClick()
        }}
      >
        <FontAwesomeIcon icon={faSortDown} />
      </div>
    ),
  }

  const orderComponent = order && orderComponents[order]

  if (orderComponent) return orderComponent

  return (
    <div
      className={styles.sort}
      onClick={() => {
        onClick()
      }}
    >
      <FontAwesomeIcon icon={faSort} />
    </div>
  )
}
